// extracted by mini-css-extract-plugin
module.exports = {"OutlineButton":"styles_OutlineButton__2uq1Z"};